import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

export const getSecuFundingAndLiquidityThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_FUNDING_AND_LIQUIDITY',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getFundingAndLiquidity(data)
    if (response.success) {
      dispatch(
        calculateDefaultUnit({
          screen: SCREEN.FINANCIAL_ANALYSIS,
          getValues: () => mapAllVNDValue(response.data),
        }),
      )
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadSecuFundingAndLiquidity = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_FUNDING_AND_LIQUIDITY',
  async (data) => {
    const response = await FinancialAnalysisService.downloadFundingAndLiquidity(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
